import './Header.css';
import icon from "../../images/icon.jpg";
import { Component } from 'react';
import { Link } from 'react-router-dom';

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = { isMenuExpanded: false };
    this.openHamburgerMenu = this.openHamburgerMenu.bind(this);
    this.closeHamburgerMenu = this.closeHamburgerMenu.bind(this);
  }

  openHamburgerMenu() {
    if (!this.state.isMenuExpanded) {
      this.setState({ isMenuExpanded: true });
    }
  }

  closeHamburgerMenu() {
    if (this.state.isMenuExpanded) {
      this.setState({ isMenuExpanded: false });
      const element = document.getElementById('hamburger-menu');
      element.click();
    }
  }

  render() {
    return (
      <header className="header">
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container-fluid">
            <Link onClick={this.closeHamburgerMenu} to="/">
              <img className="d-inline-block header__icon" src={icon} alt="icon sign" />
            </Link>
            <button className="me-4 navbar-toggler" id="hamburger-menu" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" onClick={this.openHamburgerMenu}>
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="w-100 d-flex justify-content-evenly align-items-center navbar-nav mb-lg-0">
                <li className="text-primary header__item">
                  <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="/">Главная</Link>
                </li>
                <li className="text-primary header__item">
                  <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="news">Новости</Link>
                </li>
                <li className="dropdown">
                  <span className="text-primary header__item dropdown-toggle" id="navbarDropdown" role="button" data-bs-toggle="dropdown">
                    Соревнования
                  </span>
                  <ul className="dropdown-menu header__dropdown-menu">
                    <li className="header__dropdown-item">
                      <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="calendars">Календарь</Link>
                    </li>
                    <li className="header__dropdown-item">
                      <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="protocols">Протоколы</Link>
                    </li>
                  </ul>
                </li>
                <li className="text-primary header__item">
                  <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="documents">Документы</Link>
                </li>
                <li className="text-primary header__item">
                  <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="information">Информация</Link>
                </li>
                {/*<li className="text-primary header__item">
                  <Link className="header__menu-link" onClick={this.closeHamburgerMenu} to="history">История</Link>
                </li>*/}
              </ul>
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

export default Header;